// extracted by mini-css-extract-plugin
export default {"table_row":"about_table_row__7kZoW","map_chip":"about_map_chip__DU+Zy"};